import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import { App } from './App';
import { initSentry } from './lib/sentry';

// Sprint 2.6.5 — Sentry admin-only (web-comite + web-admin). Fire-and-forget;
// no-op se VITE_SENTRY_DSN ausente.
void initSentry();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
